import { forEach } from 'lodash'
import Vue from 'vue'
import App from './App'
import Router from './router.js'
import Store from './store'
import './functions'
import './filters'
import './directives'

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import Pagination from '@/components/global/Pagination'
Vue.component('pagination', Pagination);

import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)

import VuejsDialog from 'vuejs-dialog'
Vue.use(VuejsDialog);

import Notifications from 'vue-notification'
Vue.use(Notifications)

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
  color: '#25daa5',
  failedColor: '#f05528',
  thickness: '4px',
  autoFinish: false
});

import VModal from 'vue-js-modal'
Vue.use(VModal, {
  dynamic: true,
  dynamicDefaults: {
    clickToClose: false,
    height: 'auto',
    scrollable: true,
  }
});

import TextareaAutosize from 'vue-textarea-autosize'
Vue.use(TextareaAutosize);

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_APIURL;

import VeeValidate, { Validator } from 'vee-validate'
Vue.use(VeeValidate)
const dictionary = {
  en: {
    messages:{
      required: () => 'This field is required',
      email: () => 'Invalid email address',
    }
  },
};
Validator.localize(dictionary);

Vue.config.productionTip = false;

new Vue({
  router: Router,
  store: Store,
  created () {
    let self = this;

    axios.interceptors.request.use(config => {
      if (config.url.indexOf('user/notification') == -1)
        self.$Progress.start();

      const accessToken = self.$localStorage.get('access_token');
      if ( accessToken ) {
        config.headers.common['Authorization'] = 'Bearer ' + accessToken;
      }

      return config;
    }, error => {
      self.$Progress.fail();
      return Promise.reject(error);
    });

    axios.interceptors.response.use(response => {
      self.$Progress.finish();
      return response;
    }, error => {
      let errors = [], msgs = '';

      self.$Progress.fail();

      if ( !error.response ) {
        self.$notify({
          type: 'error',
          title: 'Invalid Request',
          text: 'Sorry, we could not locate the resource you are trying to get.',
        });
        return Promise.reject(error);
      }

      switch (error.response.status) {
        case 401:
          self.$router.push({ name: 'login' });
          break;
        case 422:
          errors = error.response.data.errors;
          msgs = [];

          forEach(errors, (val) => {
            msgs.push( val[0] );
          });

          self.$notify({
            type: 'error',
            title: 'Form validation failed',
            text: msgs.join('<br>'),
          });
          break;
        case 403:
          self.$notify({
            type: 'error',
            title: 'Permission denied',
            text: 'Sorry, you are not allow to perform this action.',
          });
          // self.$router.push({ name: 'not-found' });
          break;
        case 500:
          self.$notify({
            type: 'error',
            title: 'Internal server error',
            text: 'Please reload the application and try again.',
          });
          break;
        case 404:
          self.$notify({
            type: 'error',
            title: 'Invalid Request',
            text: 'Sorry, we could not locate the resource you are trying to get.',
          });
          break;
      }
      return Promise.reject(error);
    });
  },
  render: h => h(App)
}).$mount('#app')
